import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var E_ACCESS_MODE;
(function (E_ACCESS_MODE) {
    E_ACCESS_MODE["READ"] = "READ";
    E_ACCESS_MODE["WRITE"] = "WRITE";
})(E_ACCESS_MODE || (E_ACCESS_MODE = {}));
export var AccessItem = function (props) {
    var i18n = props.i18n, access = props.access;
    var description = getPropsByKeyPath(i18n, 'modules.timeline.access.message');
    var username = access.username, mode = access.mode;
    var readLabel = mode === E_ACCESS_MODE.READ ? getPropsByKeyPath(i18n, 'modules.timeline.access.readMode') : '';
    return (_jsx(_Fragment, { children: _jsxs("p", { children: [_jsx("b", { children: username }), " ", description, " ", readLabel] }) }));
};
